import { Component, OnInit, OnChanges, Input, SimpleChanges, OnDestroy, EventEmitter } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import * as languageLibrary from '../../../../services/language'
// services
import { MessageService } from "../../../../services/message.service";
import { MasterService } from "../../../../services/master.service";
import { StoreService } from "../../../../services/store.service";
import { SecurityService } from '../../../../services/security.service'
//
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { SALE_TYPES } from "src/app/constants/sale"
import { Subscription } from "rxjs";

@Component({
    selector: 'print-center',
    templateUrl: './print-center.component.html',
    styleUrls: ['./print-center.component.scss'],
    standalone: false
})
export class PrintCenterComponent implements OnInit, OnChanges, OnDestroy {

    // Unique internal identity of the sale
    @Input() saleId: number = 0

    private lotId: number | null = null

    private lotAddress: Object | null = null

    private inventoryId: number | null = null

    // A list of available forms for the sale.
    protected forms: Object[] = []

    // A grouping of the existing forms suitable for display in the UI.
    protected groups: Record<string, Record<string, any[]>> = {}

    protected showMergeDocumentSection: boolean = false

    //
    protected hideNoCopies: boolean = false

    // save the language
    protected language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'

    // set all words
    protected words = languageLibrary.language

    // oder of table
    protected order: Object = { isAscend: false, type: '' }

    // files
    protected files = []

    //
    protected emails: string[] = []

    //
    protected documents: Object[] = []

    //
    protected documentSelected: Object[] = []

    // loading status
    protected loading: boolean = false

    protected pdf: any = null

    //
    protected emailForm = new FormGroup({
        subject: new FormControl<string>('', [Validators.required]),
        bodyText: new FormControl<string>('', [Validators.required])
    })

    protected setupValuesString: string | null = null;
    protected selectedForm: any;
    //
    protected imagesValid: string[] = ['jpeg', 'jpg', 'png', 'bmp', 'gif', 'eps', 'svg', 'heic', 'heif']
    protected x: number = 0;
    protected y: number = 0;
    protected isManaged: boolean = false;
    protected item: any;

    // A handle to navbar event messages so we can unsubscribe later.
    private componentWatcher: Subscription | null = null

    get groupKeys() { return this.groups ? Object.keys(this.groups) : [] }
    protected formKeys(group: string) { return (this.groups && this.groups[group]) ? Object.keys(this.groups[group]) : [] }
    protected copies(group: string, form: string) { return (this.groups && this.groups[group] && this.groups[group][form] && this.groups[group][form].length > 0) ? this.groups[group][form][0].copies : 0 }
    protected revision(group: string, form: string) { return (this.groups && this.groups[group] && this.groups[group][form] && this.groups[group][form].length > 0) ? this.groups[group][form][0].revision : 0 }
    protected allowSetupValueChanges(group: string, form: string) { return (this.groups && this.groups[group] && this.groups[group][form] && this.groups[group][form].length > 0) ? this.groups[group][form][0].allowSetupValueChanges : 0 }
    protected setupValues(group: string, form: string) { return (this.groups && this.groups[group] && this.groups[group][form] && this.groups[group][form].length > 0) ? this.groups[group][form][0].setupValues : 0 }
    protected managed(group: string, form: string) { return (this.groups && this.groups[group] && this.groups[group][form] && this.groups[group][form].length > 0) ? this.groups[group][form][0].managed : 0 }
    protected coordinates(group: string, form: string) { return (this.groups && this.groups[group] && this.groups[group][form] && this.groups[group][form].length > 0) ? this.groups[group][form][0].coordinatesId : 0 }
    protected form(group: string, form: string) { return (this.groups && this.groups[group] && this.groups[group][form] && this.groups[group][form].length > 0) ? this.groups[group][form][0] : 0 }
    protected formOptions(group: string, form: string) { return (this.groups && this.groups[group] && this.groups[group][form] && this.groups[group][form].length > 0) ? this.groups[group][form] : [] }
    protected formOptionCount(group: string, form: string) { return (this.groups && this.groups[group] && this.groups[group][form] && this.groups[group][form].length > 0) ? this.groups[group][form].length : 0 }

    constructor(private route: ActivatedRoute, private ms: MessageService, private master: MasterService, private store: StoreService, public security: SecurityService, private sanitizer: DomSanitizer) {}

    ngOnInit() {
        this.componentWatcher = this.ms.channelComponents$.subscribe(res => {
            if (!res || !res.message) {
                return
            }

            switch (res.message) {
                case 'saleTypeChanged':
                case 'coBuyerChanged':
                case 'cobuyerDiscarded':
                case 'vehicleChanged':
                case 'tradeChanged':
                case 'lienholderChanged':
                    this.fetch()
                    break
                case 'vehicleRead':
                case 'vehicleAdded':
                    this.inventoryId = res.value.inventoryId
                    break
                case 'vehicleDiscarded':
                    this.inventoryId = null
                    this.fetch()
                    break

            }
        })

        this.lotId = parseInt(localStorage.getItem('lot') || this.store.lotSelected)
        this.fetch()
    }

    ngOnDestroy() {
        if (!this.componentWatcher) {
            return
        }

        this.componentWatcher.unsubscribe()
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes) {
            return
        }

        const first = Object.values(changes).some(c => c.isFirstChange())
        if (first) {
            return
        }

        if (changes.saleId) {
            this.fetch()
        }
    }

    /**
     * Get a list of forms matching the current state of the sale.
     */
    public fetch = async () => {
        if (!this.saleId || (this.saleId <= 0)) {
            return
        }

        this.forms = []
        this.groups = {}

        this.lotId = parseInt(localStorage.getItem('lot') || this.store.lotSelected)
        const lotState = await this.determineLotState()

        let stateParam = ''
        if (lotState && (lotState.length === 2)) {
            stateParam = `&state=${lotState}`
        }

        let saleParam = ''
        if (this.saleId > 0) {
            saleParam = `&saleId=${this.saleId}`
        }

        const res = await this.master.getAsync(`forms?lotId=${this.lotId}${stateParam}${saleParam}&panel=print-center&module=sales`)

        if (!res || (res['status'] !== 200)) {
            this.ms.sendMessage("alert", { type: "danger", text: res ? res['data'].error : this.words[this.language]['apiNoResponse'] })
            return
        }
        
        this.forms = res.data.forms
        this.groups = this.grouped()
    }

    /**
    * Group the current forms list by category and name 
    * so they are ready for display in the UI.
    */
    public grouped = (): Record<string, Record<string, any[]>> => {
        const groups = {}

        if (!this.forms || (this.forms.length <= 0)) {
            return
        }

        for (const form of this.forms) {
            if (!groups[form['category']]) {
                groups[form['category']] = {}
            }


            if (!groups[form['category']][form['name']]) {
                groups[form['category']][form['name']] = []
            }

            const duplicate = groups[form['category']][form['name']].find(groupForm => form['id'] == groupForm['id'])
            if (duplicate) {
                continue
            }

            groups[form['category']][form['name']].push({
                id: parseInt(form['id']),       //stateFormId
                formId: parseInt(form['formId']),
                producer: form['producer'],
                copies: parseInt(form['copies']),
                selected: (groups[form['category']][form['name']].length <= 0),
                revision: form['revision'],
                allowSetupValueChanges: form['allowSetupValueChanges'],
                setupValues: form['setupValues'],
                name: form['name'],
                managed: form['managed'],
                coordinatesId: form['coordinatesId']
            })
        }

        return groups
    }

    /**
    * 
    * @param group 
    * @param form 
    */
    public view = (group, form) => {
        this.isManaged = false
        if (!this.groups || !group || !form) {
            return
        }

        let index = 0
        if (this.formOptionCount(group, form) > 1) {
          const select = document.getElementById(
            `form-option-index-${form}`,
          ) as HTMLSelectElement;
          const selectedOption = select.options[select.selectedIndex];

          index = Number(selectedOption.getAttribute("data-i"))
        }

        if (!this.groups[group] || !this.groups[group][form] || (this.groups[group][form].length <= 0)) {
            return
        }

        this.item = this.groups[group][form][index]
        this.isManaged = this.managed(group, form)

        this.download(this.item.id, form)
    }

    /**
    * Download the given form from the API.
    * @param id Unique internal identity of the form to construct and download.
    * @param name The name of the form to download.
    */
    public download = (id: number, name: string, adjustment?) => {
        if (!this.saleId || this.saleId <= 0) {
            return
        }

        if (!id || id <= 0) {
            return
        }

        this.pdf = null
        const payload = {
            forms: [
                {
                    formId: id,
                    module: 'sales',
                    copies: 1,
                    xChange: adjustment ? this.x : null,
                    yChange: adjustment ? this.y : null
                }
            ]
        }

        const btn = document.getElementById('btn-view-pdf-modal') as HTMLButtonElement
        if (btn && !adjustment) {
            btn.click()
        }

        let invParam = ''
        if (this.inventoryId && (this.inventoryId > 0)) {
            invParam = `&inventoryId=${this.inventoryId}`
        }

        this.master.post(`forms?lotId=${this.lotId}&saleId=${this.saleId}${invParam}`, payload, (meta) => {
            if (!meta || !meta.status || !meta.data || !meta.data.url) {
                this.ms.sendMessage("alert", { type: "danger", text: (meta && meta.error) ? meta.error : this.words[this.language]['apiNoResponse'] })
                return
            }

            const url: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(meta.data.url)
            if (!url) {
                this.ms.sendMessage("alert", { type: "danger", text: "Pdf meta data url is empty or null." })
                return
            }

            this.pdf = url
        })
    }

    /**
    * Download all forms with copy counts greater than zero.
    * @param {Event} e The event meta data that triggered this method.
    */
    public bulk = (e: Event) => {
        e.preventDefault()
        e.stopPropagation()
        this.hidePrintCenterActionsMenu()

        if (!this.saleId || this.saleId <= 0) {
            return
        }

        if (!this.forms || (this.forms.length <= 0)) {
            return
        }

        if (!this.groups) {
            return
        }

        this.pdf = null
        const payload = {
            forms: []
        }

        let copies = 0
        let formId = 0
        for (const category of Object.keys(this.groups)) {
            for (const form of Object.keys(this.groups[category])) {
                copies = 0
                formId = 0

                for (const item of this.groups[category][form]) {
                    if (!item.selected) {
                        continue
                    }

                    copies = item.copies
                    formId = item.id

                    if (!copies || (copies <= 0)) {
                        continue
                    }

                    if (!formId || (formId <= 0)) {
                        continue
                    }

                    payload.forms.push({
                        formId: formId,
                        module: 'sales',
                        copies: copies,
                        xChange: null,
                        yChange: null
                    })
                }
            }
        }

        if (!payload || !payload.forms || (payload.forms.length <= 0)) {
            return
        }

        const btn = document.getElementById('btn-view-pdf-modal') as HTMLButtonElement
        if (btn) {
            btn.click()
        }

        let invParam = ''
        if (this.inventoryId && (this.inventoryId > 0)) {
            invParam = `&inventoryId=${this.inventoryId}`
        }

        this.master.post(`forms?lotId=${this.lotId}&saleId=${this.saleId}${invParam}`, payload, (meta) => {
            if (!meta || !meta.status || !meta.data) {
                this.ms.sendMessage("alert", { type: "danger", text: (meta && meta.error) ? meta.error : this.words[this.language]['apiNoResponse'] })
                return
            }

            const url: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(meta.data.url)
            if (!url) {
                this.ms.sendMessage("alert", { type: "danger", text: "Pdf meta data url is empty or null." })
                return
            }

            this.pdf = url
        })
    }

    /**
    * Set all form copy counts to zero to start fresh.
    * @param {Event} e The event meta data that triggered this method.
    */
    public zeroCopies = (e: Event) => {
        e.preventDefault()
        e.stopPropagation()
        this.hidePrintCenterActionsMenu()

        if (!this.forms || (this.forms.length <= 0)) {
            return
        }

        if (!this.groups) {
            return
        }

        for (const form of this.forms) {
            for (const item of this.groups[form['category']][form['name']]) {
                item.copies = 0
            }
        }
    }

    /**
    * Restore all form copy counts to their original values.
    * @param {Event} e The event meta data that triggered this method.
    */
    public resetCopies = (e: Event) => {
        e.preventDefault()
        e.stopPropagation()
        this.hidePrintCenterActionsMenu()

        if (!this.forms || (this.forms.length <= 0)) {
            return
        }

        if (!this.groups) {
            return
        }

        for (const form of this.forms) {
            for (const item of this.groups[form['category']][form['name']]) {
                item.copies = parseInt(form['copies'])
            }
        }
    }

    /**
    * Toggle the print cetner actions 
    * dropdown so it hides after an option 
    * is selected.
    */
    private hidePrintCenterActionsMenu = () => {
        const btn = (document.getElementById('print-center-actions') as HTMLButtonElement)
        if (!btn) {
            return
        }

        btn.click()
    }

    /**
    * 
    * @param e 
    * @param group 
    * @param form 
    */
    public changed = (e: Event, group: string, form: string) => {
        if (!this.groups || !group || !form) {
            return
        }

        if (!this.groups[group] || !this.groups[group][form] || (this.groups[group][form].length <= 0)) {
            return
        }

        for (const item of this.groups[group][form]) {
            item.copies = parseInt((e.target as HTMLInputElement).value)
        }
    }

    /**
    * 
    * @param e 
    * @param group 
    * @param form 
    * @param id 
    */
    public optionChanged = (e: Event, group: string, form: string) => {
        if (!e.target || !this.groups || !group || !form) {
            return
        }

        if (!this.groups[group] || !this.groups[group][form] || (this.groups[group][form].length <= 0)) {
            return
        }

        const id = parseInt((e.target as HTMLSelectElement).value)
        const found = this.groups[group][form].find(option => option.id === id)
        if (!found) {
            return
        }

        for (const item of this.groups[group][form]) {
            if (item.id === id) {
                item.selected = true
                continue
            }

            item.selected = false
        }
    }

    /**
    * Query for or used cached sale lot state.
    * @returns A two-character state abbreviation for the associated sale lot
    */
    private determineLotState = async () => {
        if (!this.lotId || (this.lotId <= 0)) {
            return null
        }

        if (this.lotAddress) {
            return this.lotAddress['state']
        }

        const res = await this.master.getAsync(`lots/${this.lotId}`)
        if (!res || !res.data || !res.data['lotDetails'] || !res.data['lotDetails']['contact'] ||
            !res.data['lotDetails']['contact']['contactAddresses'] || (res.data['lotDetails']['contact']['contactAddresses'].length <= 0)) {
            return null
        }

        const addy = res.data['lotDetails']['contact']['contactAddresses'].find(addy => addy.primaryAddress == 1)
        if (!addy || !addy.state) {
            return null
        }

        this.lotAddress = addy
        return this.lotAddress['state']
    }

    // todo: get reports
    public generateReport = async (document: Object) => {

    }

    public openModal(group, form) {
        this.setupValuesString = this.setupValues(group, form)
        this.selectedForm = this.form(group, form)
        document.getElementById("btn-view-dynamicSetupForm-modal").click()
    }


    public adjustCoordinates(action) {
        let incrementByInches = document.getElementById('incrementByInches')['value']
        let pixels = incrementByInches * 72
        switch (action) {
            case 'left':
                this.x += -pixels
                break;
            case 'right':
                this.x += pixels
                break;
            case 'up':
                this.y += pixels
                break;
            case 'down':
                this.y += -pixels
                break;
            case 'reset':
                this.y = 0
                this.x = 0
                break;

            default:
                break;
        }

        this.download(this.item.id, this.item.name, true)
    }

    public saveCoordinates() {
        let coordinateId = this.item.coordinatesId
        if (!coordinateId || isNaN(coordinateId) || (coordinateId <= 0)) {
            this.createPrinterConfiguration()
            return
        }

        this.updatePrinterConfiguration(coordinateId)
    }
    public updatePrinterConfiguration = async (coordinateId: number) => {
        let coordinates = { y: this.y, x: this.x }
        this.master.patch(`forms/${this.item.id}/printer/${coordinateId}`, { coordinates }, res => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return;
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return;
            }
        })
    }

    createPrinterConfiguration() {
        let coordinates = { y: this.y, x: this.x }
        this.master.post(`forms/${this.item.id}/printer`, { coordinates }, res => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return;
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return;
            }
        })
    }
}
